import DevelopmentInProgress from "../../../components/common/DevelopmentInProgress";
import ReportHeaderComponent from "../reportHeaderComponent";
import React from 'react';

export default function ReportPageNotFound({ activeTab, setIsCollapse, isCollapse }) {
  return <div>
    <div className="header-position-sticky" style={{ backgroundColor: '#FFF' }}>
      <ReportHeaderComponent
        title={activeTab}
        subtitle={false}
        setIsCollapse={setIsCollapse}
        isCollapse={isCollapse}
        activeTab={activeTab}
        fromDate={''}
        toDate={''}
        buttons={[]}
      />
    </div>
    <DevelopmentInProgress />
  </div>;
}